import { SetState } from 'zustand';
import { Club, Payment, PlanStore } from './types';

const createPlanSlice = (set: SetState<PlanStore>) => ({
  planOptions: {
    club: {
      club_name: '',
      club_value: 0,
      club_description: '',
      type_club: 0,
      covers: []
    } as Club,
    payment: {
      membership_fee: { methods: [] },
      installments: { methods: [] }
    } as Payment
  },

  setClub: (club: Club) => {
    set((state) => ({ planOptions: { ...state.planOptions, club } }));
  },

  setPayment: (payment: Payment) => {
    set((state) => ({ planOptions: { ...state.planOptions, payment } }));
  }
});

export default createPlanSlice;
